import URLS from '~/constants/urls';

const PACKAGE = 'com.husqvarna.hfshybrid';

export const buildAndroidIntentUrl = (currentUrl: string = globalThis.location.href): string => {
  const u = new URL(currentUrl);
  const tail = `${u.host}${u.pathname}${u.search}${u.hash}`;
  const fallback = encodeURIComponent(URLS.GOOGLE_PLAY_STORE_URL);
  return `intent://${tail}#Intent;scheme=https;package=${PACKAGE};S.browser_fallback_url=${fallback};end`;
};
